import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// ApolloModule and other dependencies
import { HttpClientModule } from '@angular/common/http';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import {
  MutateLocationGQL,
  FindNearestLocationsByCoordinatesGQL
} from './graphql';
import { Environment } from '../environment';

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }
};

export function createApollo(httpLink: HttpLink, env: Environment) {
  return {
    link: httpLink.create({
      uri: env.api
    }),
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions
  };
}

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule, ApolloModule, HttpLinkModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, Environment]
    },
    MutateLocationGQL,
    FindNearestLocationsByCoordinatesGQL
  ]
})
export class GraphqlClientModule {}
